import { render, staticRenderFns } from "./_base-course-author-bio.vue?vue&type=template&id=7d9b2ac8"
import script from "./_base-course-author-bio.vue?vue&type=script&lang=js"
export * from "./_base-course-author-bio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports